import toast from "react-hot-toast";

export const copyToClipboard = (text, alert) => {
  navigator.clipboard.writeText(text ?? "")
  toast.success(alert ? alert : "Successfully copied!");
};